@let isBuy = side() === orderSideEnum.BUY;

<div [class]="['trade-side-toggle', isBuy ? 'buy' : 'sell']">
	<app-button
		class="btn"
		[size]="size()"
		[appearance]="isBuy ? 'positive' : 'flat'"
		(clicked)="sideChange.emit(orderSideEnum.BUY)"
	>
		{{ 'tradeSideToggle.buy' | translate }}
	</app-button>
	<app-button
		class="btn"
		[size]="size()"
		[appearance]="!isBuy ? 'negative' : 'flat'"
		(clicked)="sideChange.emit(orderSideEnum.SELL)"
	>
		{{ 'tradeSideToggle.sell' | translate }}
	</app-button>
</div>
